export default ({ FONT_SIZES }) => ({
  container: {
    ...FONT_SIZES.HEADING_MEDIUM.STYLE,
    display: 'flex',
    alignItems: 'center',
    width: '162px',
    justifyContent: 'space-between',
    userSelect: 'none',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      width: '119px',
      background: '#fff',
      padding: '5px',
      borderRadius: '36px'
    }
  },
  icon: {
    cursor: 'pointer',
    [`@media (max-width: 920px) and (orientation: landscape)`]: {
      height: '36px',
      width: '36px'
    }
  }
})
